export const text =
  '10 月 26 号！TiDB 地区交流活动（杭州站）-走进电魂网络｜一起聊聊核心系统上 TiDB 的收益和体验 & 多业务场景怎么在 TiDB 一站式实现！';
export const link = 'https://asktug.com/t/topic/1032923';
